import { FC, useState, useEffect } from "react";
import Select from '@atomaro/ui-kit/components/Select/Select';
import { Icon, Wrapper } from "./style";
import { toRem } from "shared/helpers";
import { IDropdownMenuItem } from "@atomaro/ui-kit/components/DropdownMenu/types";
import { COLORS } from "shared/consts";

type SortSelectProps = {
    items: IDropdownMenuItem[];
    defaultValue?: string;
    isMobile?: boolean;
    value?: string;
    direction?: "ASC" | "DESC";
    onChange?: (value: string) => void;
    disabled?: boolean;
};

export const SortSelect: FC<SortSelectProps> = ({
    items,
    defaultValue,
    isMobile,
    value,
    direction = "DESC",
    disabled = false,
    onChange
}) => {

    const normalizeValue = (val?: string) => val?.replace("-ASC", "");

    const [ lastValue, setLastValue ] = useState<string | undefined>(
        normalizeValue(value) || defaultValue
    );

    useEffect(() => {
        if (value !== undefined) {
            setLastValue(normalizeValue(value));
        }
    }, [value]);

    const onSelectChange = (value: string | number) => {
      if (value) {
        const stringValue = `${value}`;
        setLastValue(normalizeValue(stringValue));
        onChange?.(stringValue)
        return
      }

      const currentValue = lastValue || defaultValue;
      if (currentValue) {
        onChange?.(`${currentValue}-ASC`)
      }
    }

    const handleSortToggle = () => {
      const currentValue = lastValue || defaultValue || items[0]?.key;
      if (!currentValue) return;

      const nextValue: string =
        direction === "ASC" ? String(currentValue) : `${currentValue}-ASC`;
      onChange?.(nextValue);
    };

    return (
        <Wrapper $isMobile={isMobile} $disabled={disabled}>
            <Icon $isMobile={isMobile} $direction={direction} onClick={handleSortToggle}>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M16.6667 5.41666H3.33337V4.16666H16.6667V5.41666ZM3.33337 10.625H13.3334V9.375H3.33337V10.625ZM3.33337 15.8333H10V14.5833H3.33337V15.8333Z" fill={isMobile ? COLORS.FG.DEFAULT : COLORS.ACCENT.DEFAULT}/>
                </svg>
            </Icon>
            <Select
                dropdownMenuStyle={{maxHeight: toRem(300), overflowY: "auto", left: toRem(-38)}}
                iconSuffix={null}
                placement="bottom"
                value={value || defaultValue}
                items={items}
                placeholder={`${items.find(el => el.key === (value || lastValue || defaultValue))?.value || 'Сортировка'}`}
                autocomplete={{enabled: false}}
                useInPortal={false}
                onChange={onSelectChange}
                size={isMobile ? 's' : 'm'}
            />
        </Wrapper>
    )
}